import styled from 'styled-components'
import CheckBoxInputSet from '@pc/components/Works/Panel/shared/checkbox/CheckBoxInputSet'

const CheckBoxFeatureInputSet = styled(CheckBoxInputSet)`
  width: 33%;
`

export default CheckBoxFeatureInputSet
